// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-9d7960d0]{font-size:1.17em}.oecp-md-category-tag[data-v-9d7960d0]{display:inline-block;margin-right:10px;margin-bottom:10px}.oecp-md-element-list[data-v-9d7960d0]{background-color:#fff}.el-tag--plain[data-v-9d7960d0]{background-color:#edf2ff;border-color:#90afff;color:#497ee1;cursor:pointer}.el-tag--dark[data-v-9d7960d0]{background-color:#73b9ff;border-color:#7399ff;color:#fff}", ""]);
// Exports
module.exports = exports;
